module.exports = __webpack_public_path__ + "static/Icons_Refinance_small-fa078a93bc8f345f9535d1e7665dd461.png";